<top-bar-tabs></top-bar-tabs>
<br />
<div class="container">
  <div class="filters">
    <deal-search [control]="filterControls.controls.project_id"></deal-search>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select [formControl]="filterControls.controls.consent_status_id">
        <mat-option>&mdash;</mat-option>
        @for (status of consentRequestsService.consentStatuses$ | async; track status) {
          <mat-option
            [value]="status.id">
            {{ status.status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Request Type</mat-label>
      <mat-select
        [formControl]="filterControls.controls.consent_request_type_id">
        <mat-option>&mdash;</mat-option>
        @for (
          consentType of consentRequestsService.consentRequestTypes$
          | async
          ; track
          consentType) {
          <mat-option
            [value]="consentType.id">
            {{ consentType.request_type }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Received</mat-label>
      <input
        [formControl]="filterControls.controls.received_date"
        matInput
        [matDatepicker]="picker" />
      <mat-datepicker-toggle
        matIconSuffix
      [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="filters">
    <mat-form-field>
      <mat-label>Consent Manager</mat-label>
      <mat-select [formControl]="filterControls.controls.consent_manager_id">
        <mat-option>&mdash;</mat-option>
        <mat-option value="">Unassigned</mat-option>
        @for (
          person of consentRequestsService.consentRequestAssignees$
          .consentManagers | async
          ; track
          person) {
          <mat-option
            [value]="person.id"
            >{{ person.name }}</mat-option
            >
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Investor Relations</mat-label>
        <mat-select [formControl]="filterControls.controls.investor_relations_id">
          <mat-option>&mdash;</mat-option>
          <mat-option value="">Unassigned</mat-option>
          @for (
            person of consentRequestsService.consentRequestAssignees$
            .investorRelations | async
            ; track
            person) {
            <mat-option
              [value]="person.id"
              >{{ person.name }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Asset Manager</mat-label>
          <mat-select [formControl]="filterControls.controls.asset_manager_id">
            <mat-option>&mdash;</mat-option>
            <mat-option value="">Unassigned</mat-option>
            @for (
              person of consentRequestsService.consentRequestAssignees$
              .assetManagers | async
              ; track
              person) {
              <mat-option
                [value]="person.id"
                >{{ person.name }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Underwriter</mat-label>
            <mat-select [formControl]="filterControls.controls.underwriter_id">
              <mat-option>&mdash;</mat-option>
              <mat-option value="">Unassigned</mat-option>
              @for (
                person of consentRequestsService.consentRequestAssignees$
                .underwriters | async
                ; track
                person) {
                <mat-option
                  [value]="person.id"
                  >{{ person.name }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Fund Manager</mat-label>
              <mat-select [formControl]="filterControls.controls.fund_manager_id">
                <mat-option>&mdash;</mat-option>
                <mat-option value="">Unassigned</mat-option>
                @for (
                  person of consentRequestsService.consentRequestAssignees$
                  .fundManagers | async
                  ; track
                  person) {
                  <mat-option
                    [value]="person.id"
                    >{{ person.name }}</mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Disposition Associate</mat-label>
                <mat-select
                  [formControl]="filterControls.controls.disposition_associate_id">
                  <mat-option>&mdash;</mat-option>
                  <mat-option value="">Unassigned</mat-option>
                  @for (
                    person of consentRequestsService.consentRequestAssignees$
                    .dispositionAssociates | async
                    ; track
                    person) {
                    <mat-option
                      [value]="person.id"
                      >{{ person.name }}</mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="table-header">
                <div class="table-label">
                  <h2>Requests</h2>
                  @if (
                    consentRequestsService.permission$ | async | permission: '_create'
                    ) {
                    <button
                      class="add-button"
                      (click)="openDialog()"
                      >
                      <mat-icon [inline]="true">add_box</mat-icon>
                    </button>
                  }
                </div>
                <span class="pagination-container">
                  @if (consentRequestsService.consentsLoading$ | async) {
                    <mat-spinner
                    class="consents-loading-spinner"></mat-spinner>
                  }
                  <mat-paginator
                    class="mat-paginator-sticky"
                    [pageSize]="perPage"
                    [hidePageSize]="true"
                    [showFirstLastButtons]="true"
                    [pageIndex]="currentPage - 1"
                    (page)="getPage($event)"
                    [length]="total"
        [disabled]="
          !!(consentRequestsService.consentsLoading$ | async)
        "></mat-paginator>
                </span>
                <div class="bonus-scroll" #scroller (scroll)="scrollerOnScroll($event)">
                  <div></div>
                </div>
              </div>

              <div class="table-container" #container (scroll)="tableOnScroll($event)">
                <table mat-table [dataSource]="requests" #sizeBasis>
                  <ng-container matColumnDef="indicators">
                    <th mat-header-cell *matHeaderCellDef=""></th>
                    <td mat-cell *matCellDef="let item">
                      <span class="indicators">
                        <button
                          matTooltip="Checklist Tasks"
                          mat-icon-button
                          (click)="openChecklistDialog(item.consentRequest.id)">
                          <consent-checklist-indicator
                [indicatorState]="
                  item.indicators.checklist
                "></consent-checklist-indicator>
                        </button>
                        <button
                          matTooltip="Investor Approvals"
                          mat-icon-button
                          (click)="openApprovalDialog(item.consentRequest.id)">
                          <consent-approval-indicator
                [indicatorState]="
                  item.indicators.approvals
                "></consent-approval-indicator>
                        </button>
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="deal">
                    <th mat-header-cell *matHeaderCellDef="">Deal</th>
                    <td mat-cell *matCellDef="let item">
                      <contact-link [subject]="item.deal"></contact-link>
                      @if (item.sponsor) {
                        <contact-link [subject]="item.sponsor"></contact-link>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="request_type">
                    <th mat-header-cell *matHeaderCellDef="">Request Type</th>
                    <td mat-cell *matCellDef="let item">{{ item.request_type }}</td>
                  </ng-container>
                  <ng-container matColumnDef="request_details">
                    <th mat-header-cell *matHeaderCellDef="">Request Details</th>
                    <td mat-cell *matCellDef="let item">
                      {{ item.request_details }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="received">
                    <th mat-header-cell *matHeaderCellDef="">Received</th>
                    <td mat-cell *matCellDef="let item">{{ item.received }}</td>
                  </ng-container>
                  <ng-container matColumnDef="timing">
                    <th mat-header-cell *matHeaderCellDef="">Timing/Urgency</th>
                    <td mat-cell *matCellDef="let item">
                      <span class="timing-wrapper">
                        <span class="timing-side">
                          <span class="date">
                            <mat-icon [class]="item.timing.is_urgent ? 'urgent' : ''">{{
                              item.timing.is_urgent ? "flag" : "outlined_flag"
                            }}</mat-icon>
                            @if (item.timing.due_date?.length) {
                              <span>{{
                                item.timing.due_date
                              }}</span>
                            }
                          </span>
                          <span class="urgency-note">{{
                            item.timing.urgency_comment
                          }}</span>
                        </span>
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef="">Status</th>
                    <td mat-cell *matCellDef="let item">{{ item.status }}</td>
                  </ng-container>
                  <ng-container matColumnDef="consent_manager">
                    <th mat-header-cell *matHeaderCellDef="">Consent Manager</th>
                    <td mat-cell *matCellDef="let item">
                      <contact-link [subject]="item.consent_manager"></contact-link>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="investor_relations">
                    <th mat-header-cell *matHeaderCellDef="">Investor Relations</th>
                    <td mat-cell *matCellDef="let item">
                      <contact-link [subject]="item.investor_relations"></contact-link>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="asset_manager">
                    <th mat-header-cell *matHeaderCellDef="">Asset Manager</th>
                    <td mat-cell *matCellDef="let item">
                      <contact-link [subject]="item.asset_manager"></contact-link>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="underwriter">
                    <th mat-header-cell *matHeaderCellDef="">Underwriter</th>
                    <td mat-cell *matCellDef="let item">
                      <contact-link [subject]="item.underwriter"></contact-link>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="fund_manager">
                    <th mat-header-cell *matHeaderCellDef="">Fund Manager</th>
                    <td mat-cell *matCellDef="let item">
                      <contact-link [subject]="item.fund_manager"></contact-link>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="disposition_associate">
                    <th mat-header-cell *matHeaderCellDef="">Disposition Associate</th>
                    <td mat-cell *matCellDef="let item">
                      <contact-link [subject]="item.disposition_associate"></contact-link>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef=""></th>
                    <td mat-cell *matCellDef="let item">
                      @if (!!(consentRequestsService.permission$ | async)?._edit) {
                        <button
                          mat-icon-button
                          (click)="openEditDialog(item.consentRequest)">
                          <mat-icon>edit</mat-icon>
                        </button>
                      }
                      @if (!!(consentRequestsService.permission$ | async)?._delete) {
                        <button
                          mat-icon-button
                          color="warn"
                          (click)="deleteRequest(item.consentRequest.id)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="columns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columns"
        [class]="{
          alert: row.past_due === IndicatorState.ALERT,
          error: row.past_due === IndicatorState.ERROR
        }"></tr>
                  <tr class="mat-row" *matNoDataRow>
                    @if (consentRequestsService.consentsLoading$ | async) {
                      <td
                        class="mat-cell-load"
                        [attr.colspan]="columns.length">
                        <mat-progress-spinner></mat-progress-spinner>
                      </td>
                    }
                    @if (!(consentRequestsService.consentsLoading$ | async)) {
                      <td
                        class="mat-cell"
                        [attr.colspan]="columns.length">
                        No consent requests found.
                      </td>
                    }
                  </tr>
                </table>
              </div>
            </div>
